module.exports = __webpack_public_path__ + "static/media/hk.96b17e72.svg";